import {bool, func, object} from 'prop-types';
import React from 'react';
import {useDispatch} from 'react-redux';
import DeleteModal from '../../common/DeleteModal.jsx';

import {notify} from '@actions/notifications';
import {deselectFeatureRef} from '@actions/selected-features';
import {trackEvent} from '@app/analytics';
import {useDeleteFeature} from '@app/api/features';
import {getErrorMessage} from '@app/api/util';

const EVENT_NAME = 'Delete Collection Modal';

const DeleteFeatureModal = ({open, onClose, feature}) => {
  const dispatch = useDispatch();

  const {mutate: deleteFeature, isPending: isDeletingFeature} =
    useDeleteFeature({
      onSuccess: () => {
        trackEvent('Delete Modal', {
          action: 'Deleted feature ',
        });
        dispatch(deselectFeatureRef());
        onClose();
      },
      onError: error => {
        dispatch(
          notify({
            severity: 'error',
            message: getErrorMessage(error, 'Feature could not be deleted'),
          })
        );
      },
    });

  const onDelete = () => {
    deleteFeature({feature});
  };

  const handleOnClose = () => {
    trackEvent(EVENT_NAME, {
      action: 'closed modal',
    });

    onClose();
  };

  return (
    <DeleteModal
      open={open}
      onClose={handleOnClose}
      title="Delete feature?"
      description="Are you sure you want to delete this feature? Doing so will remove it from your organization’s view."
      isPending={isDeletingFeature}
      onDelete={onDelete}
    />
  );
};

DeleteFeatureModal.propTypes = {
  feature: object,
  onClose: func,
  open: bool,
};

export default DeleteFeatureModal;
